export default [

     {
          path: '/automation-execution',
          name: 'AutomationExecution',
          component: () => import("@/views/Page/AutomationExecution/AutomationExecution.vue"),
           meta: {
               title: '#Default# | AutomationExecution',
          },
     },
     {
          path: '/automation-rule-executions/:ruleId',
          name: 'RuleAutomationExecution',
          component: () => import("@/views/Page/AutomationExecution/AutomationExecution.vue"),
           meta: {
               title: 'AutomationExecution',
          },
     }
];